import { createSlice } from '@reduxjs/toolkit';
import { Service } from 'services/Services';
import { RequestApi } from 'RequestApi';
import { NotificationMessage } from 'components/notification-message/NotificationMessage';

const initialState = {
  formLoading: false,
  progressing: false,
  objectGroups: [],
  record: null,
  pageInfo: null,
  showAttachment: false,
};

const documentFormSlice = createSlice({
  name: 'documentForm',
  initialState,
  reducers: {
    setPageInfo(state, action) {
      state.pageInfo = action.payload;
    },
    receiveService(state, action) {
      const { objectGroups, record, formLoading } = action.payload;
      state.objectGroups = objectGroups;
      state.record = record;
      state.formLoading = formLoading;
    },
    setFormLoading(state, action) {
      state.formLoading = action.payload;
    },
    setProgressing(state, action) {
      state.progressing = action.payload;
    },
    openLookup(state, action) {
      state.dynamicLookup = action.payload;
    },

    // Line
    setUpdateLineRecord(state, action) {
      const { record, subRecord, keyTableLine, lineUnid } = action.payload;
      const resRecord = record;
      const fieldNames = Object.keys(resRecord);
      const tmpRecord = { ...state.record };

      fieldNames.forEach((fieldName) => {
        tmpRecord[fieldName] = resRecord[fieldName];
      });

      const index = tmpRecord[keyTableLine].findIndex((element) => element.id.toString() === lineUnid.toString());
      if (index !== -1) {
        tmpRecord[keyTableLine][index] = subRecord;
        state.record = tmpRecord;
      }
    },

    setStoreLineRecord(state, action) {
      const { subRecord, keyTableLine } = action.payload;
      const tmpRecord = { ...state.record };
      tmpRecord[keyTableLine].push(subRecord);
      state.record = tmpRecord;
    },

    setDeleteLineRecord(state, action) {
      const { keyTableLine, subUnid } = action.payload;
      const tmpRecord = { ...state.record };
      const index = tmpRecord[keyTableLine].findIndex((element) => element.id.toString() === subUnid.toString());
      if (index !== -1) {
        tmpRecord[keyTableLine].splice(index, 1);
        state.record = tmpRecord;
      }
    },

    setDeleteAllLineRecords(state, action) {
      const { keyTableLine } = action.payload;
      const tmpRecord = { ...state.record };
      tmpRecord[keyTableLine] = [];
      state.record = tmpRecord;
    },

    setRecord(state, action) {
      state.record = action.payload;
    },

    toggleAttachment(state, action) {
      state.showAttachment = action.payload;
    },
  },
});

const { setPageInfo, setProgressing, setUpdateLineRecord, setStoreLineRecord, setDeleteAllLineRecords, setDeleteLineRecord } = documentFormSlice.actions;

export const { receiveService, setFormLoading, setRecord, toggleAttachment } = documentFormSlice.actions;

export const initPageInfo =
  ({ informationPage, unid }) =>
  async (dispatch) => {
    try {
      dispatch(setFormLoading(true));
      dispatch(setPageInfo(informationPage));

      let url = `${informationPage.url}/index-card?`;
      url += `auth_token=${Service.userToken}`;

      const data = JSON.stringify({
        data_unid: unid,
      });

      RequestApi(url, {
        data,
      })
        .then((res) => {
          if (res.data.status === 'success') {
            const objectGroups = [...res.data.object.object_groups];
            // objectGroups.forEach((objectGroup) => {
            //   objectGroup.object_group_fields.forEach((objectGroupFields) => {
            //     objectGroupFields.status_force_read_only = '1';

            //     // console.log(`re : ${objectGroupFields.status_force_read_only}`);
            //   });
            // });

            dispatch(receiveService({ objectGroups, record: res.data.record, formLoading: false }));
          } else {
            NotificationMessage({ message: res.data.msg, status: res.data.status });
          }
        })
        .catch((err) => {
          console.log(err);
          NotificationMessage({ message: err.toString(), status: 'error' });
        });
    } catch (ex) {
      NotificationMessage({ message: ex.toString(), status: 'error' });
    }
  };

export const updateRecord =
  ({ url, unid, objectGroupField, valueChanged }) =>
  async (dispatch) => {
    try {
      dispatch(setProgressing(true));

      let urlRequest = `${url}/update-record?`;
      urlRequest += `auth_token=${Service.userToken}`;
      urlRequest += '&source_type=api';

      const data = JSON.stringify({
        field_name: objectGroupField.field_name,
        unid,
        object_group_field_id: objectGroupField.object_group_field_id,
        value: valueChanged,
        object_group_id: objectGroupField.object_group_id,
        sub_unid: '',
      });

      RequestApi(urlRequest, {
        data,
      })
        .then((res) => {
          if (res.data.status === 'success') {
            dispatch(setRecord(res.data.record));
          } else {
            NotificationMessage({ message: res.data.msg, status: res.data.status });
          }
          dispatch(setProgressing(false));
        })
        .catch((err) => {
          dispatch(setProgressing(false));
          NotificationMessage({ message: err.toString(), status: 'error' });
        });
    } catch (ex) {
      dispatch(setProgressing(false));
      NotificationMessage({ message: ex.toString(), status: 'error' });
    }
  };

export const updateLineRecord =
  ({ url, unid, objectGroupField, valueChanged, lineUnid, lineIndex, keyTableLine }) =>
  async (dispatch) => {
    try {
      dispatch(setProgressing(true));

      let urlRequest = `${url}/update-line-record?`;
      urlRequest += `auth_token=${Service.userToken}`;
      urlRequest += '&source_type=api';

      const data = JSON.stringify({
        field_name: objectGroupField.field_name,
        unid,
        object_group_field_id: objectGroupField.object_group_field_id,
        value: valueChanged,
        object_group_id: objectGroupField.object_group_id,
        sub_unid: lineUnid,
      });

      RequestApi(urlRequest, {
        data,
      })
        .then((res) => {
          if (res.data.status === 'success') {
            dispatch(setUpdateLineRecord({ record: res.data.record, subRecord: res.data.sub_record, lineUnid, keyTableLine }));
          } else {
            NotificationMessage({ message: res.data.msg, status: res.data.status });
          }
          dispatch(setProgressing(false));
        })
        .catch((err) => {
          dispatch(setProgressing(false));
          NotificationMessage({ message: err.toString(), status: 'error' });
        });
    } catch (ex) {
      NotificationMessage({ message: ex.toString(), status: 'error' });
      dispatch(setProgressing(false));
    }
  };

export const addNewLineRecord =
  ({ url, unid, objectGroupId, keyTableLine }) =>
  async (dispatch) => {
    try {
      dispatch(setProgressing(true));

      let urlRequest = `${url}/store-line-record?`;
      urlRequest += `auth_token=${Service.userToken}`;

      const data = JSON.stringify({
        unid,
        object_group_id: objectGroupId,
      });

      RequestApi(urlRequest, {
        data,
      })
        .then((res) => {
          if (res.data.status === 'success') {
            dispatch(setStoreLineRecord({ subRecord: res.data.sub_record, keyTableLine }));
          } else {
            NotificationMessage({ message: res.data.msg, status: res.data.status });
          }
          dispatch(setProgressing(false));
        })
        .catch((err) => {
          dispatch(setProgressing(false));
          NotificationMessage({ message: err.toString(), status: 'error' });
        });
    } catch (ex) {
      dispatch(setProgressing(false));
      NotificationMessage({ message: ex.toString(), status: 'error' });
    }
  };

export const deleteAllLineRecords =
  ({ url, unid, subUnid, objectGroupId, keyTableLine }) =>
  async (dispatch) => {
    try {
      dispatch(setProgressing(true));

      let urlRequest = `${url}/delete-all-line-record?`;
      urlRequest += `auth_token=${Service.userToken}`;

      const data = JSON.stringify({
        unid,
        object_group_id: objectGroupId,
      });

      RequestApi(urlRequest, {
        data,
      })
        .then((res) => {
          if (res.data.status === 'success') {
            dispatch(setDeleteAllLineRecords({ keyTableLine }));
          } else {
            NotificationMessage({ message: res.data.msg, status: res.data.status });
          }
          dispatch(setProgressing(false));
        })
        .catch((err) => {
          dispatch(setProgressing(false));
          NotificationMessage({ message: err.toString(), status: 'error' });
        });
    } catch (ex) {
      dispatch(setProgressing(false));
      NotificationMessage({ message: ex.toString(), status: 'error' });
    }
  };

export const deleteLineRecord =
  ({ url, unid, subUnid, objectGroupId, keyTableLine }) =>
  async (dispatch) => {
    try {
      dispatch(setProgressing(true));

      let urlRequest = `${url}/delete-line-record?`;
      urlRequest += `auth_token=${Service.userToken}`;

      const data = JSON.stringify({
        unid,
        object_group_id: objectGroupId,
        sub_unid: subUnid,
      });

      RequestApi(urlRequest, {
        data,
      })
        .then((res) => {
          if (res.data.status === 'success') {
            dispatch(setDeleteLineRecord({ keyTableLine, subUnid }));
          } else {
            NotificationMessage({ message: res.data.msg, status: res.data.status });
          }
          dispatch(setProgressing(false));
        })
        .catch((err) => {
          dispatch(setProgressing(false));
          NotificationMessage({ message: err.toString(), status: 'error' });
        });
    } catch (ex) {
      dispatch(setProgressing(false));
      NotificationMessage({ message: ex.toString(), status: 'error' });
    }
  };

const documentFormReducer = documentFormSlice.reducer;

export default documentFormReducer;
